module.exports = __webpack_public_path__ + "Sauer.jpg?dc360f2fe944a0a30eccf005550efbcd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Sauer.jpg
// module id = 32
// module chunks = 0